<mat-card>
  <mat-card-content>
    <div fxLayout="column">
      <div class="input-row" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="10px">
          <div class="mat-elevation-z8">
            <table mat-table [dataSource]="dataSource" class="applications-table">
              <ng-container matColumnDef="creationDateTime">
                <th mat-header-cell *matHeaderCellDef>Fecha</th>
                <td mat-cell *matCellDef="let element"> {{ element.creationDateTime | date: 'dd-MMM-yyyy hh:mm a' : 'GMT-5' }}</td>
              </ng-container>
              <ng-container matColumnDef="detail">
                <th mat-header-cell *matHeaderCellDef>Detalle</th>
                <td mat-cell *matCellDef="let element">
                  <span [class.error-text]="element.status === 'ERROR'">{{ element.detail }}</span>
                </td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
              <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell" colspan="4">No hay mensajes</td>
              </tr>
            </table>
          </div>
      </div>
    </div>
  </mat-card-content>
  <mat-card-actions align="end">
    <button mat-button mat-dialog-close (click)="closeWindow()">Cerrar</button>
  </mat-card-actions>
</mat-card>


